<template>
    <v-checkbox
        :value="filterItem.active"
        :input-value="filterItem.active"
        @click.prevent="filterBy(filterItem)"
        :ripple=false
        hide-details
    >
        <template v-slot:label>
           <span
               v-if="filterType === 'availability'"
               class="legend-color"
               :style="{ backgroundColor: 'rgb(' + filterItem.color + ')' }"
           />
            <span class="habiteo-body-2">
                {{ filterType === 'floor' ? filterItem.text : filterName }} {{ showPlotCount ? '(' + filterItem.hotspots.length + ')' : '' }}
            </span>
        </template>
    </v-checkbox>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "TextItem",
        props: {
            filterItem: {
                type: Object,
                required: true,
            },
            filterName: {
                type: String,
                required: true,
            },
            filterType: {
                type: String,
                required: true,
            }
        },
        computed: {
            ...mapGetters('widget', [
                'showPlotCount'
            ]),
        },
        methods: {
            filterBy(filter) {
                this.$emit('filter-method', filter);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
</style>



// WEBPACK FOOTER //
// src/components/filters/TextItem.vue